module.exports = __webpack_public_path__ + "img/1525007742.6f882139.jpg";